export function updateBadgeCount(unreadCount: number): void {
  const cordova = window['cordova'];
  if (!cordova || cordova.platformId !== 'ios') {
    return;
  }

  const badge = cordova.plugins?.notification?.badge;
  if (!badge) {
    return;
  }

  const count = Math.max(0, Math.floor(unreadCount));
  badge.set(count, () => {
    console.log('Badge set to', count);
  });
}

export function getTotalUnreadBadgeCount(
  notificationCount: number,
  chatCount: number
): number {
  return Math.max(0, notificationCount + chatCount);
}